import './App.css'
import AboutCard from '../about/AboutCard'
import ProjectCards from '../card/ProjectCards'
import TimelineStory from '../timeline/Timeline'
import FooterD from '../footer/footer'

function App() {
  return (
    <div className="App">
      <>
        <AboutCard />
        <ProjectCards />
        <TimelineStory />
        <FooterD />
      </>
    </div>
  )
}

export default App
